import { useRef, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { toast } from "sonner";
import { Paperclip, X, Loader2 } from "lucide-react";
import { Button } from "../ui/button";

export default function AttachmentPicker({ value = [], onChange, testid = "att" }) {
  const inputRef = useRef();
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange([...value, { path: data.path, filename: data.filename, content_type: file.type }]);
      toast.success("Attached");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = (i) => onChange(value.filter((_, idx) => idx !== i));

  return (
    <div className="space-y-2">
      <input ref={inputRef} type="file" hidden onChange={onFile} data-testid={`${testid}-input`} />
      <Button type="button" size="sm" variant="outline" className="border-[#E4E7EC]" onClick={() => inputRef.current?.click()} disabled={busy} data-testid={`${testid}-btn`}>
        {busy ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" /> : <Paperclip className="w-3.5 h-3.5 mr-1" />}
        {busy ? "Uploading..." : "Attach file"}
      </Button>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {value.map((a, i) => (
            <div key={i} className="text-[11px] font-mono px-2 py-1 rounded border border-[#E4E7EC] bg-[#FFFFFF] flex items-center gap-2" data-testid={`${testid}-item-${i}`}>
              <Paperclip className="w-3 h-3 text-orange-400" />
              <span className="truncate max-w-[180px]">{a.filename}</span>
              <button type="button" onClick={() => remove(i)} className="text-neutral-500 hover:text-rose-700" data-testid={`${testid}-remove-${i}`}>
                <X className="w-3 h-3" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
